module.exports = __webpack_public_path__ + "img/fb-messenger.27a56841.svg";